import { render, staticRenderFns } from "./Previouscallsformsheet.vue?vue&type=template&id=0f971a4e"
import script from "./Previouscallsformsheet.vue?vue&type=script&lang=js"
export * from "./Previouscallsformsheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports